import { ReactNode } from 'react';
import styles from './success-message.module.css';

interface Props {
    children: ReactNode
}
const SuccessMessage = ({ children }: Props) => (
    <div className={styles.successMessage}>
        ✅ {children}
    </div>
);

export default SuccessMessage;